export const footerMoreLinks = {
  'sa-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://sa.wingie.com/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://sa.wingie.com/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://sa.wingie.com/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://sa.wingie.com/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://sa.wingie.com/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://sa.wingie.com/blog/',
          title: 'المدونة',
        },
        {
          href: 'https://sa.wingie.com/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'sa-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://sa.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://sa.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://sa.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://sa.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://sa.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://sa.wingie.com/en/blog/',
          title: 'Blog',
        },
        {
          href: 'https://sa.wingie.com/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'sa-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://sa.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://sa.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://sa.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://sa.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://sa.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://sa.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'sa-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://sa.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://sa.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://sa.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://sa.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://sa.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://sa.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'sa-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://sa.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://sa.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://sa.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://sa.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://sa.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://sa.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'sa-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://sa.wingie.com/it/contact/', title: 'Contatto' },
        // { href: 'https://sa.wingie.com/it/faq/', title: 'Domande frequenti' },
        { href: 'https://sa.wingie.com/it/about-us/', title: 'Chi siamo' },
        { href: 'https://sa.wingie.com/it/privacy/', title: 'Privacy' },
        { href: 'https://sa.wingie.com/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://sa.wingie.com/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'sa-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://sa.wingie.com/fr/contact/', title: 'Contact' },
        // { href: 'https://sa.wingie.com/fr/faq/', title: 'Questions fréquemment posées' },
        { href: 'https://sa.wingie.com/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://sa.wingie.com/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://sa.wingie.com/fr/terms-and-conditions/', title: 'Conditions générales' },
        { href: 'https://sa.wingie.com/fr/awards/', title: 'Nos prix' },
      ],
    },
  ],
  'sa-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://sa.wingie.com/pt/contact/', title: 'Contato' },
        // { href: 'https://sa.wingie.com/pt/faq/', title: 'Perguntas frequentes' },
        { href: 'https://sa.wingie.com/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://sa.wingie.com/pt/privacy/', title: 'Privacidade' },
        { href: 'https://sa.wingie.com/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://sa.wingie.com/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'sa-ro': [
    {
      title: 'Mai mult',
      items: [
        { href: 'https://sa.wingie.com/ro/contact/', title: 'Contact' },
        // { href: 'https://sa.wingie.com/ro/faq/', title: 'Întrebări frecvente' },
        { href: 'https://sa.wingie.com/ro/about-us/', title: 'Despre noi' },
        { href: 'https://sa.wingie.com/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://sa.wingie.com/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://sa.wingie.com/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'sa-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://sa.wingie.com/pl/contact/', title: 'Kontakt' },
        // { href: 'https://sa.wingie.com/pl/faq/', title: 'Często zadawane pytania' },
        { href: 'https://sa.wingie.com/pl/about-us/', title: 'O nas' },
        { href: 'https://sa.wingie.com/pl/privacy/', title: 'Prywatność' },
        { href: 'https://sa.wingie.com/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://sa.wingie.com/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'sa-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://sa.wingie.com/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://sa.wingie.com/lt/faq/', title: 'Dažniausiai užduodami klausimai' },
        { href: 'https://sa.wingie.com/lt/about-us/', title: 'Apie mus' },
        { href: 'https://sa.wingie.com/lt/privacy/', title: 'Privatumas' },
        { href: 'https://sa.wingie.com/lt/terms-and-conditions/', title: 'Naudojimo sąlygos' },
        { href: 'https://sa.wingie.com/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'sa-uz': [
    {
      title: 'Boshqa',
      items: [
        { href: 'https://sa.wingie.com/uz/contact/', title: 'Aloqa' },
        // { href: 'https://sa.wingie.com/uz/faq/', title: "Tez-tez so'raladigan savollar" },
        { href: 'https://sa.wingie.com/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://sa.wingie.com/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://sa.wingie.com/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://sa.wingie.com/uz/awards/', title: 'Bizning mukofotlarimiz' },
      ],
    },
  ],
  'sa-sr': [
    {
      title: 'Više',
      items: [
        { href: 'https://sa.wingie.com/sr/contact/', title: 'Kontakt' },
        // { href: 'https://sa.wingie.com/sr/faq/', title: 'Često postavljana pitanja' },
        { href: 'https://sa.wingie.com/sr/about-us/', title: 'O nama' },
        { href: 'https://sa.wingie.com/sr/privacy/', title: 'Privatnost' },
        { href: 'https://sa.wingie.com/sr/terms-and-conditions/', title: 'Uslovi korišćenja' },
        { href: 'https://sa.wingie.com/sr/awards/', title: 'Naše nagrade' },
      ],
    },
  ],
  'sa-ky': [
    {
      title: 'Дагы',
      items: [
        { href: 'https://sa.wingie.com/ky/contact/', title: 'Байланыш' },
        // { href: 'https://sa.wingie.com/ky/faq/', title: 'Көп берилүүчү суроолор' },
        { href: 'https://sa.wingie.com/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://sa.wingie.com/ky/privacy/', title: 'Купуялык' },
        { href: 'https://sa.wingie.com/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://sa.wingie.com/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'sa-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://sa.wingie.com/tg/contact/', title: 'Тамос' },
        // { href: 'https://sa.wingie.com/tg/faq/', title: 'Саволҳои зиёд пурсидашаванда' },
        { href: 'https://sa.wingie.com/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://sa.wingie.com/tg/privacy/', title: 'Махфият' },
        { href: 'https://sa.wingie.com/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://sa.wingie.com/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'sa-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://sa.wingie.com/kk/contact/', title: 'Байланыс' },
        // { href: 'https://sa.wingie.com/kk/faq/', title: 'Жиі қойылатын сұрақтар' },
        { href: 'https://sa.wingie.com/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://sa.wingie.com/kk/privacy/', title: 'Құпиялылық' },
        { href: 'https://sa.wingie.com/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://sa.wingie.com/kk/awards/', title: 'Біздің марапаттар' },
      ],
    },
  ],
  'sa-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://sa.wingie.com/nl/contact/', title: 'Contact' },
        // { href: 'https://sa.wingie.com/nl/faq/', title: 'Veelgestelde vragen' },
        { href: 'https://sa.wingie.com/nl/about-us/', title: 'Over ons' },
        { href: 'https://sa.wingie.com/nl/privacy/', title: 'Privacy' },
        { href: 'https://sa.wingie.com/nl/terms-and-conditions/', title: 'Voorwaarden' },
        { href: 'https://sa.wingie.com/nl/awards/', title: 'Onze prijzen' },
      ],
    },
  ],
  'sa-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://sa.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://sa.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://sa.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://sa.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://sa.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://sa.wingie.com/ja/awards/' },
      ],
    },
  ],
  'sa-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://sa.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://sa.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://sa.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://sa.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://sa.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://sa.wingie.com/zh/awards/' },
      ],
    },
  ],
  'sa-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://sa.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://sa.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://sa.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://sa.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://sa.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://sa.wingie.com/ko/awards/' },
      ],
    },
  ],
  'sa-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://sa.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://sa.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://sa.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://sa.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://sa.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://sa.wingie.com/hi/awards/' },
      ],
    },
  ],
  'sa-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://sa.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://sa.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://sa.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://sa.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://sa.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://sa.wingie.com/ta/awards/' },
      ],
    },
  ],
  'sa-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://sa.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://sa.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://sa.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://sa.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://sa.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://sa.wingie.com/th/awards/' },
      ],
    },
  ],
  'sa-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://sa.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://sa.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://sa.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://sa.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://sa.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://sa.wingie.com/ur/awards/' },
      ],
    },
  ],
  'sa-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://sa.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://sa.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://sa.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://sa.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://sa.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://sa.wingie.com/ka/awards/' },
      ],
    },
  ],
}
